<template>
  <b-row class="m-1 m-sm-4">
    <feature-list-item
      v-for="item in items"
      :key="`feature-item${item.id}`"
      class="col-md-6 col-lg-4 col-xl-3 col-12"
      :item="item"
    ></feature-list-item>
  </b-row>
</template>

<script>
export default {
  name: 'FeatureList',
  props: {
    items: {
      required: true,
      type: Array,
    },
  },
};
</script>

<style></style>
